import { OnInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  DatosBaseResolucionEntity, ServicioResolucion0256Service,
  FiltrosResolucionSp2BodyEntity, EntidadEmpresarial,
  FiltrosResolucionEntity } from '../../services/servicio-resolucion0256.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FiltrosResolucionSp4BodyEntity, FiltrosResolucionSp6BodyEntity } from '../../services/servicio-resolucion0256.service';
import { ImagesService } from '../../services/utils/images.service';

/*
Autor: David Centeno
email: davidcenteno@outlook.es
Fecha de creación: 14 de Agosto de 2019
*/

@Component({
  selector: 'app-reporte-resolucion0256',
  templateUrl: './reporte-resolucion0256.component.html',
  styleUrls: ['./reporte-resolucion0256.component.css']
})
export class ReporteResolucion0256Component implements OnInit {
  mostrarReporte = true; // se usa en la restriccion de la hora para generar el reporte.
  loading: boolean;
  downloading: boolean;
  logo: string;
  user: string;
  nombreUser: string;
  filtrosSeleccionados: FiltrosResolucionEntity;
  detalleSp2: FiltrosResolucionSp2BodyEntity[] = [];
  detalleSp4: FiltrosResolucionSp4BodyEntity[] = [];
  detalleSp6: FiltrosResolucionSp6BodyEntity[] = [];

  fechaImpresion: Date;
  enviados: number;
  atendidos: number;
  pendientes: number;

  public datosBaseResolucionEntity: DatosBaseResolucionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: 0,
    uncoEntidad: ''
  };

  entidadEmpresarial: EntidadEmpresarial = {
    unco: 0,
    nombreEntidad: '',
    nit: '',
    direccion: 0,
    telefono: '',
  };

  public objetoResolucion: FiltrosResolucionEntity = {
    codigoBaseDatos: '',
    fechaInicial: 0,
    fechaFinal: 0,
    empresa: ''
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioImagenes: ImagesService,
    private servicioResolucion0256: ServicioResolucion0256Service,
    ) {

    this.activatedRoute.params.subscribe(params => {
      this.datosBaseResolucionEntity.codigoBaseDatos = params['codigoBaseDatos'];
      this.datosBaseResolucionEntity.uncoSede = params['uncoSede'];
      this.datosBaseResolucionEntity.uncoEntidad = params['uncoEntidad'];
      this.datosBaseResolucionEntity.uncoLogin = params['user'];
      this.filtrosSeleccionados = this.objetoResolucion;
    });

  }

  ngOnInit() {
    this.filtrosSeleccionados = this.objetoResolucion;
    this.getLogo(this.objetoResolucion.codigoBaseDatos);
    this.fechaImpresion = new Date();
  }

  public onFiltrosCompletados(obj: FiltrosResolucionEntity) {
    this.loading = true;
    this.filtrosSeleccionados = obj;
    this.filtrosSeleccionados.codigoBaseDatos = this.datosBaseResolucionEntity.codigoBaseDatos;
    this.fechaImpresion = new Date();
    this.getLogo(obj.codigoBaseDatos);
    this.getData();
  }

  public updateEntidad(entidad: EntidadEmpresarial) {
    this.entidadEmpresarial = entidad;
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.logo = '';
      this.loading = true;
      const response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: any) => {
          this.logo = data.source;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.logo = '';
          this.loading = false;
        });
      }
    } catch (e) {
      this.logo = '';
      this.loading = false;
    }
  }

  mostrarLoadingFiltros(loading: any) {
    this.loading = true;
  }

  async getData() {
    try {
      const responseSp2 = await this.servicioResolucion0256.getResolucionDataSp2(this.filtrosSeleccionados);
      const responseSp4 = await this.servicioResolucion0256.getResolucionDataSp4(this.filtrosSeleccionados);
      const responseSp6 = await this.servicioResolucion0256.getResolucionDataSp6(this.filtrosSeleccionados);

      if (responseSp2 != null) {
        responseSp2.subscribe((data: FiltrosResolucionSp2BodyEntity[]) => {
          this.detalleSp2 = data;
          this.loading = false;
          if (data == null) {
            this.mostrarReporte = false;
          }
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
      if (responseSp4 != null) {
        responseSp4.subscribe((data: FiltrosResolucionSp4BodyEntity[]) => {
          this.detalleSp4 = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
      if (responseSp6 != null) {
        responseSp6.subscribe((data: FiltrosResolucionSp6BodyEntity[]) => {
          this.detalleSp6 = data;
          this.loading = false;
          // console.log('getData SP6 response SP6: ' + responseSp6 + ' data:' + JSON.stringify(data));
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }
}
